// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import FAQKnowledgeCenterPage from "../pages/FAQKnowledgeCenter/FAQKnowledgeCenter";
const __wvcRoutePaths = ["/FAQKnowledgeCenterPage", "/knowledge-center"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about", "aboutpage", "contact", "contactpage", "faqknowledgecenterpage", "home", "homepage", "insurance-retirement-glossary", "insuranceretirementglossarypage", "knowledge-center", "post", "search"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<FAQKnowledgeCenterPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<FAQKnowledgeCenterPage />} />
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
